module.exports = "/_next/static/images/c2471a8aa2d198930090f70dd06eb433-credit-card-prepayment@1x.png.webp";